import React, { useMemo } from 'react';
import {
  SelectInput,
  ReferenceInput,
  ReferenceArrayInput,
  Query
} from 'react-admin';
import { Grid, Typography } from '@material-ui/core/';
import { find } from 'lodash';
import GridInputFilter from '../../core/components/inputs/GridInputFilter';

const validateCategories = (value, allValues, props, field) => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Category must be selected';
  }
  return undefined;
};

const GroupCategorySummary = props => {
  const { isDisplayAdminCategoriesOn } = props;
  const creationFilter = useMemo(() => {
    return isDisplayAdminCategoriesOn
      ? { orphanVisibility: 'ALL_VISIBLE' }
      : { orphanVisibility: 'ALL_VISIBLE', subType: 'REPORTING' };
  }, [isDisplayAdminCategoriesOn]);

  if (props.creation) {
    return (
      <div>
        <Grid container spacing={1}>
          {!props.categoryOrSubcategoryIds && (
            <Grid item sm={12}>
              <Query
                type="GET_MANY_REFERENCE"
                resource="groupcategories"
                payload={{
                  target: 'groupId',
                  id: props.groupId,
                  sort: {}
                }}
              >
                {({ data, total, loading, error }) => {
                  if (!loading && !error) {
                    const filter = choices => {
                      return choices.filter(
                        item =>
                          find(data, ['categoryOrSubcategoryId', item.id]) ===
                          undefined
                      );
                    };
                    return (
                      <ReferenceArrayInput
                        label="To add Category to this Group, select one or multiple items from the list of the Categories below."
                        optionTextLabel="Category Name"
                        optionValueLabel="Category ID"
                        resource="categories"
                        reference="categories"
                        source="categoryOrSubcategoryIds"
                        validate={[validateCategories]}
                        perPage={-1}
                        filter={creationFilter}
                      >
                        <GridInputFilter
                          choicesToExclude={data}
                          filterOptionValue="categoryOrSubcategoryId"
                          filter={filter}
                        />
                      </ReferenceArrayInput>
                    );
                  } else {
                    return <></>;
                  }
                }}
              </Query>
            </Grid>
          )}
        </Grid>
      </div>
    );
  } else {
    return (
      <div>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography variant="h5">Identity</Typography>
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <ReferenceInput
              label="Category Name"
              source="categoryOrSubcategoryIds"
              resource="categories"
              reference="categories"
              perPage={-1}
              filterToQuery={searchText => ({
                name: searchText ? searchText + '*' : 'A*'
              })}
            >
              <SelectInput
                options={{
                  disabled: true
                }}
                optionText="name"
                variant={props.variant}
              />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <ReferenceInput
              label="Category Description"
              source="categoryOrSubcategoryIds"
              resource="categories"
              reference="categories"
              perPage={-1}
              filterToQuery={searchText => ({
                name: searchText ? searchText + '*' : 'A*'
              })}
            >
              <SelectInput
                options={{
                  disabled: true
                }}
                optionText="description"
                variant={props.variant}
              />
            </ReferenceInput>
          </Grid>
          <Grid item sm={12} md={6} lg={6}>
            <ReferenceInput
              label="Group Name"
              source="groupId"
              resource="groups"
              reference="groups"
              perPage={-1}
              filterToQuery={searchText => ({
                name: searchText ? searchText + '*' : 'A*'
              })}
            >
              <SelectInput
                options={{
                  disabled: true
                }}
                optionText="name"
                variant={props.variant}
              />
            </ReferenceInput>
          </Grid>
        </Grid>
      </div>
    );
  }
};

export default GroupCategorySummary;
